module.exports = __webpack_public_path__ + "img/10.93f789e6.png";